import type { Product } from "../types/product";

export const products: Product[] = [
  {
    slug: "seven-sins-master",
    name: "Seven Sins – Master",
    brand: "Seven Sins",
    collection: "seven-sins",
    price: 29.95,
    category: "him",
    format: "Softgels",
    tagline: "Powerful erection support with ginseng.",
    description:
      "Seven Sins Master is a powerful erection-supporting supplement with ginseng, specially developed for men who want to enhance their sexual performance.",
    benefits: ["Supports erection and performance", "Formulated with ginseng", "Easy-to-take softgels"],
    usage: "Follow the dosage instructions on the packaging. Do not exceed the recommended daily dose.",
    images: [
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/01/seven-sins-master-side-content-2.jpg?w=900&ssl=1",
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/01/seven-sins-master-softgels-1.jpg?w=900&ssl=1",
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/01/seven-sins-master-front-1.jpg?w=900&ssl=1",
    ],
    badge: "Bestseller",
  },
  {
    slug: "pink-pussycat",
    name: "Pink Pussycat",
    brand: "Royal Honey",
    collection: "royal-honey",
    price: 14.99,
    category: "her",
    format: "Honey sachet",
    tagline: "Natural female libido honey in a single-use sachet.",
    description:
      "Boost your sexual energy and desire with Pink Pussycat Honey – a natural, edible supplement specially formulated for women. It increases blood flow to help enhance arousal and intensify orgasms, made with Fo-Ti, Yohimbe, Ginkgo Biloba and Horny Goat Weed.",
    benefits: [
      "Enhances sexual desire and energy",
      "Promotes natural lubrication",
      "Supports longer, more intense orgasms",
      "Delicious honey flavour – sugar-free & paraben-free",
      "Cruelty-free & vegan-friendly",
    ],
    usage:
      "Consume one sachet about 1 hour prior to sexual activity. Do not take with other supplements or medications within the same hour. Intended for women only.",
    ingredients: "Honey base with Fo-Ti, Yohimbe, Ginkgo Biloba and Horny Goat Weed.",
    images: [
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/06/1-1.png?w=900&ssl=1",
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/06/2.png?w=900&ssl=1",
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/06/3.png?w=900&ssl=1",
    ],
    badge: "Bestseller",
  },
  {
    slug: "vip-royal-honey",
    name: "VIP Royal Honey",
    brand: "Royal Honey",
    collection: "royal-honey",
    price: 14.99,
    category: "him",
    format: "Honey sachet · 20 ml",
    tagline: "Fast-acting liquid power — works in 10–20 minutes.",
    description:
      "Experience rapid results with VIP Royal Honey – a powerful, fast-acting liquid formula made with real honey and natural vasodilators to enhance blood flow, stamina and sexual performance in just minutes.",
    benefits: [
      "Fast-acting liquid formula – results in 10–20 minutes",
      "Helps achieve stronger, longer-lasting erections",
      "Boosts confidence and performance",
      "Large 20 ml sachet – no pills, just tear and take",
    ],
    usage:
      "Take 1 sachet orally 10–20 minutes before sexual activity. Squeeze the syrup directly into your mouth. No more than 1 sachet per day.",
    ingredients: "Real honey and natural herbs that support vasodilation and circulation.",
    images: [
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/06/494101017_1744040132848334_8509716229497011818_n.jpg?w=600&ssl=1",
      "https://rise-upp.com/wp-content/uploads/2025/06/00a0906f-93b0-4d7f-9299-0b0cd539a93f.avif",
    ],
    badge: "Hot",
  },
  {
    slug: "seven-sins-lust",
    name: "Seven Sins – Lust",
    brand: "Seven Sins",
    collection: "seven-sins",
    price: 26.95,
    category: "couples",
    format: "Capsules",
    tagline: "Ginseng formula to increase desire.",
    description:
      "Seven Sins Lust is a dietary supplement with Ginseng that helps improve sexual relationships and increase desire.",
    benefits: ["Increases desire", "Helps improve sexual relationships", "Formulated with ginseng"],
    usage: "Follow the dosage instructions on the packaging. Do not exceed the recommended daily dose.",
    images: [
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/01/seven-sins-lust-side-content-2.jpg?w=900&ssl=1",
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/01/Seven-Sins-Lust4-2.jpg?w=900&ssl=1",
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/01/Seven-Sins-Lust3-2.jpg?w=900&ssl=1",
    ],
    badge: "Bestseller",
  },
  {
    slug: "lady-in-red",
    name: "Lady in Red",
    brand: "Royal Honey",
    collection: "royal-honey",
    price: 14.99,
    category: "her",
    format: "Honey sachets · 10 g",
    tagline: "Organic aphrodisiac royal honey for her.",
    description:
      "Indulge in passion with Lady in Red – a premium organic honey blend crafted for women. Infused with natural herbs, this delicious royal honey enhances desire, arousal and intimate pleasure.",
    benefits: ["Enhances desire and arousal", "Premium organic honey blend", "Infused with natural herbs"],
    usage: "Follow the instructions on the packaging. Do not exceed one sachet per day.",
    images: [
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/06/RF-Lady-In-Red-%E2%80%A6Royal.-.Honey_.-For-Her-12-Packs-x-10-grams-3.webp?fit=1000%2C1000&ssl=1",
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/06/RF-Lady-In-Red-%E2%80%A6Royal.-.Honey_.-For-Her-12-Packs-x-10-grams.png?fit=1000%2C1000&ssl=1",
    ],
    badge: "New",
  },
  {
    slug: "seven-sins-boost",
    name: "Seven Sins – Boost",
    brand: "Seven Sins",
    collection: "seven-sins",
    price: 29.95,
    category: "him",
    format: "Tablets",
    tagline: "Maca, Guarana and Kola nut for energy and vitality.",
    description:
      "Seven Sins Boost has a favourable effect on fertility thanks to Maca. Guarana and Kola nut provide extra energy, while Muira Puama and L-Arginine support sexual health.",
    benefits: [
      "Beneficial effect on fertility thanks to Maca",
      "Guarana and Kola nut for extra energy",
      "Supports sexual health with Muira Puama and L-Arginine",
    ],
    usage: "Take 2 tablets daily with water. Dietary supplement for sexual health.",
    ingredients:
      "Per 2 tablets: Maca extract PE 5:1 (100 mg), Guarana extract (100 mg), Kola nut extract (100 mg), Muira Puama PE 4:1 (100 mg), L-Taurine (50 mg), Zinc monomethionine (83.4 mg, 100% RI), Ginkgo Biloba (40 mg), L-Arginine (20 mg), Vitamin B3 (18 mg, 100% RI).",
    images: [
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/01/Seven-Sins-Boost-2.jpg?w=900&ssl=1",
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/01/Seven-Sins-Boost2-1.jpg?w=900&ssl=1",
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/01/Seven-Sins-Boost3-1.jpg?w=900&ssl=1",
    ],
  },
  {
    slug: "spanish-fly-strong",
    name: "Spanish Fly Strong",
    brand: "Spanish Fly",
    collection: "devils-candy",
    price: 19.95,
    category: "her",
    format: "Drops",
    tagline: "Long-lasting aphrodisiac for multiple orgasms.",
    description:
      "This aphrodisiac has a long-lasting effect so that women can experience multiple orgasms and the valley orgasm.",
    benefits: ["Long-lasting effect", "Designed for women", "Discreet and easy to use"],
    usage: "Follow the instructions on the packaging.",
    images: [
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/02/Spanish-Fly-Strong-2.jpg?w=900&ssl=1",
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/02/Spanish-Fly-Strong4-2.jpg?w=900&ssl=1",
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/02/Spanish-Fly-Strong2-2.jpg?w=900&ssl=1",
    ],
  },
  {
    slug: "rhino-choco",
    name: "Rhino Choco",
    brand: "Rhino",
    collection: "royal-honey",
    price: 14.99,
    category: "him",
    format: "Chocolate",
    tagline: "5x more power than traditional aphrodisiac honeys.",
    description:
      "Rhino Choco delivers 5x more power than traditional aphrodisiac honeys. This rich, delicious chocolate is packed with premium ingredients that enhance energy, mood, stamina and sexual performance.",
    benefits: ["Enhances energy and mood", "Supports stamina and performance", "Rich, delicious chocolate"],
    usage: "Follow the instructions on the packaging.",
    images: [
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/06/475745562_10213590527354763_3544007069202821678_n.jpg?w=720&ssl=1",
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/06/475734557_10213590527274761_709163328710660899_n.jpg?w=720&ssl=1",
    ],
  },
  {
    slug: "xmax-tripleshot-energy",
    name: "Xmax Tripleshot Energy",
    brand: "Royal Honey",
    collection: "royal-honey",
    price: 14.99,
    category: "him",
    format: "Honey sachet",
    tagline: "Tongkat Ali, Ginseng and Maca honey from Malaysia.",
    description:
      "Unleash your inner power with Xmax Tripleshot – a potent aphrodisiac honey blend from Malaysia, formulated with natural ingredients like Tongkat Ali, Ginseng and Maca to boost male vitality, libido and energy.",
    benefits: ["Boosts male vitality and libido", "Tongkat Ali, Ginseng and Maca", "Natural honey blend"],
    usage: "Follow the instructions on the packaging. Do not exceed one sachet per day.",
    ingredients: "Honey, Tongkat Ali, Ginseng, Maca.",
    images: [
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/06/1-2.png?w=900&ssl=1",
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/06/2-1.png?w=900&ssl=1",
    ],
  },
  {
    slug: "black-horse-vital-honey",
    name: "Black Horse Vital Honey",
    brand: "Royal Honey",
    collection: "royal-honey",
    price: 14.99,
    category: "him",
    format: "Honey sachet · 10 g",
    tagline: "Male energy & performance honey.",
    description:
      "Black Horse Vital Honey is a male energy and performance supplement in convenient 10 g honey sachets.",
    benefits: ["Supports energy and performance", "Convenient 10 g sachets", "Natural honey base"],
    usage: "Follow the instructions on the packaging. Do not exceed one sachet per day.",
    images: [
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/06/black-horse-vital-honey-10gm-24-sachets-supplier-in-kerala.jpg?w=1024&ssl=1",
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/06/16273836284803.jpg?w=680&ssl=1",
    ],
  },
  {
    slug: "crystal-libido-jelly",
    name: "Crystal Libido Jelly",
    brand: "Crystal",
    collection: "devils-candy",
    price: 29.95,
    category: "couples",
    format: "Jelly",
    tagline: "Stimulates desire and supports fertility.",
    description: "Crystal Libido Jelly stimulates sexual desire and has a beneficial effect on fertility.",
    benefits: ["Stimulates sexual desire", "Beneficial effect on fertility", "Easy jelly format"],
    usage: "Follow the instructions on the packaging.",
    images: [
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/02/Crystal-Libido-Jelly-1.jpg?w=900&ssl=1",
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/02/Crystal-Libido-Jelly1-2.jpg?w=900&ssl=1",
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/02/Crystal-Libido-Jelly2-1.jpg?w=900&ssl=1",
    ],
  },
  {
    slug: "devils-candy-oral-jelly",
    name: "Devils Candy – Oral Jelly",
    brand: "Devils Candy",
    collection: "devils-candy",
    price: 24.95,
    category: "couples",
    format: "Oral jelly",
    tagline: "Get into the mood faster.",
    description: "Devils Candy Oral Jelly can easily be taken orally to get into a sexual mood faster.",
    benefits: ["Get in the mood faster", "Easy oral jelly", "Discreet format"],
    usage: "Follow the instructions on the packaging.",
    images: [
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/02/Devils-Candy-Oral-Jelly-1.jpg?w=900&ssl=1",
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/02/Devils-Candy-Oral-Jelly1-1.jpg?w=900&ssl=1",
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/02/Devils-Candy-Oral-Jelly2-1.jpg?w=900&ssl=1",
    ],
    badge: "Hot",
  },
  {
    slug: "devils-candy-ejact-delay-gel",
    name: "Devils Candy – Ejact Delay Gel",
    brand: "Devils Candy",
    collection: "devils-candy",
    price: 24.95,
    category: "him",
    format: "Gel",
    tagline: "Calms and cools to help you last longer.",
    description: "Devils Candy Ejact Delay Gel is a formula that helps delay orgasm. The gel calms and cools the skin.",
    benefits: ["Helps delay orgasm", "Calming, cooling sensation", "For external use"],
    usage: "Apply a small amount and massage gently. For external use only.",
    images: [
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/02/Devils-Candy-Ejact-Delay-Gel-1.jpg?w=900&ssl=1",
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/02/Devils-Candy-Ejact-Delay-Gel1-2.jpg?w=900&ssl=1",
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/02/Devils-Candy-Ejact-Delay-Gel2-2.jpg?w=900&ssl=1",
    ],
  },
  {
    slug: "high-octane-raptor",
    name: "High Octane – Raptor",
    brand: "High Octane",
    collection: "high-octane",
    price: 24.95,
    category: "couples",
    format: "Oral gel",
    tagline: "Significantly increases sex drive for him and her.",
    description: "High Octane Raptor is an oral gel that can significantly increase the sex drive of men and women.",
    benefits: ["Increases sex drive", "Suitable for men and women", "Fast oral gel"],
    usage: "Follow the instructions on the packaging.",
    images: [
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/02/High-Octane-Raptor-3.jpg?w=900&ssl=1",
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/02/High-Octane-Raptor1.jpg?w=900&ssl=1",
      "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/02/High-Octane-Raptor2.jpg?w=900&ssl=1",
    ],
  },
];
